import script from "./BoardList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BoardList.vue?vue&type=script&lang=ts&setup=true"

import "./BoardList.vue?vue&type=style&index=0&id=92bee3d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92bee3d6"]])

export default __exports__